export const env = { ...window['env'] }